import { useGoBack } from 'hooks/useGoBack';
import { RaRecord } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { OrderStatus } from 'types/embedded/orderStatus';

import { RolesEditForm } from './RolesEditForm';

const transform = ({ roleCategories, ...data }: RaRecord): RaRecord => ({
  ...data,
  roleCategories: Array.isArray(roleCategories) ? roleCategories[0] : roleCategories,
  allowedStatusesEditing: data.allowedStatusesEditing.map(
    (status: OrderStatus) => status?.value || status,
  ),
});

export const RolesEdit: React.FC = () => {
  const { goBack } = useGoBack();

  return (
    <EditGuesserPage
      listName="Роли"
      mutationOptions={{ onError: () => undefined }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" onClick={goBack} variant="outlined" />,
        <SaveButtonValidated key="save-button" label="Сохранить" />,
      ]}
      title="Редактирование роли"
      transform={transform}
    >
      <RolesEditForm />
    </EditGuesserPage>
  );
};
